import { areCareOrdersNettable, type CareOrder } from '@talos/kyoko';
import { uniq } from 'lodash-es';

export interface CareOrderNettingValidationResult {
  nettable: boolean;
  reason?: string;
}

/**
 * Given an array of Care Orders, will check that a few basic properties all line up and can be netted together.
 * If something doesn't line up, nettable: false is returned with a user-friendly csv string of failure reasons to render
 */
export function validateNetCareOrders(careOrders: CareOrder[]): CareOrderNettingValidationResult {
  const reasons: string[] = [];

  if (careOrders.length === 0) {
    reasons.push('Select at least 1 Care Order to Net');
  }

  careOrders.forEach(careOrder => {
    const canBeNetted = careOrder.canBeNetted;
    if (!canBeNetted.result && canBeNetted.failureReason != null) {
      reasons.push(canBeNetted.failureReason);
    }
  });

  // Check that all care orders are compatible with each other
  const [referenceCareOrder, ...comparisonCareOrders] = careOrders;
  if (referenceCareOrder != null) {
    let failureReason: string | undefined;
    comparisonCareOrders.some(careOrder => {
      const nettableResult = areCareOrdersNettable(referenceCareOrder, careOrder);
      if (!nettableResult.nettable) {
        failureReason = nettableResult.failureReason;
        return true;
      }

      return false;
    });

    if (failureReason != null) {
      reasons.push(failureReason);
    }
  }

  if (reasons.length > 0) {
    return {
      nettable: false,
      reason: uniq(reasons).join(', '),
    };
  }

  return {
    nettable: true,
  };
}
